export default ({ Vue }) => {
  // Add the $breadcrumbs property to the Vue instance
  Object.defineProperty(Vue.prototype, '$breadcrumbs', {
    get: function get () {
      let crumbs = []
      const matched = this.$route.matched
      matched.forEach(function (route) {
        let hasBreadcrumb = route.meta && route.meta.title
        if (hasBreadcrumb) {
          crumbs.push(route)
        }
      })
      return crumbs
    }
  })
}
